import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const SquareIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg },
    React.createElement("path", { d: "M5.1 15h10V5h-10v10zm10.75 1.5H4.35a.75.75 0 01-.75-.75V4.25a.75.75 0 01.75-.75h11.5a.75.75 0 01.75.75v11.5a.75.75 0 01-.75.75z" }),
    ' '));
export const Square = iconGenerator(SquareIcon);
//# sourceMappingURL=Square.js.map